import '../forms/helpers.js';
import { FloatingLabelInput, FloatingLabelTextarea } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class SurveysEdit extends EditPage {
  static get formAction() {
    return API.resourceUrl('surveys', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Surveys" href="/surveys" nameHref="/surveys/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/surveys"]
      <FloatingLabelInput label="Name" name="name">
      <FloatingLabelTextarea label="Description (optional)" name="description" required="false">
      br
      br
      br
      h2 Questions
      ol.questions
      br
      br
      a.add-question-link[onclick="addQuestion()"] + Add Question
      br
      br
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('surveys', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.name;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
